export default {
  title: 'Think Academy’s free maths worksheets',
  subTitle: 'Try our free maths worksheets for kindergarten and primary school pupils in K2  to Y6, created by our team of expert educators. Search for your child’s Year group below, then download and then print at home.',
  form: {
    title: `Preparing for the 11+?
    Looking for a course of maths approach?`,
    subTitle: 'We provide the past paper tests and the newest information for free!',
    submitBtn: 'Get Past Papers and Practice Papers',
    tip: `
    By clicking “Get Past Papers and Practice Papers” you explicitly agree to Think Academy AUS emailing you free learning resources and offers about our other services. You can unsubscribe at any time.`,
    leadText: 'Or join parent group to learn more',
    leadBtn: 'Join Group',
    toolsList: [],
  },
}
